import React, { useEffect } from "react";
import drone from "../../assets/image/png/by_drone.svg";
import image1 from "../../assets/image/png/drone_part.svg";
import image2 from "../../assets/image/png/find_job.svg";
import image3 from "../../assets/image/png/piloat.png";
import right_arrow from "../../assets/image/png/right_arrow.png";
import { useNavigate, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getBlogs } from "../../redux/slice/blogSlice";
import HTMLReactParser from "html-react-parser";
import Slider from "react-slick";

const HowWeCanHelp = () => {
  const navigate = useNavigate();
  const { blogs } = useSelector((state) => state.blog);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getBlogs({ page: 1, limit: 5 }));
  }, [dispatch]);

  function descriptionShort(item, index) {
    const first200Chars = `${item.description.split("").slice(0, 200).join("")}...`;
    return first200Chars;
  }

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth" // Optional: Smooth scrolling animation
    });
  };

  const blogSliderSettings = {
    dots: false,
    infinite: true,
    arrows: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true, // Enable automatic scrolling
    autoplaySpeed: 3000, // Set autoplay speed to 0 for continuous scroll
    cssEase: 'linear', // Use linear easing for continuous scrolling
    pauseOnHover: false, // Prevent pause on hover
    pauseOnFocus: false, // Prevent pause on focus
    pauseOnDotsHover: false, // Prevent pause on dots hover
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div className="col-lg-4 detail_box rounded-4 px-lg-0 custom_top position-sticky h-100 overflow-y-auto" >
  <div>
    <div className="tab_btn rounded-4 p-4">
      <h4 className="fs_26 ff_inter fw-bold text-white text-center">
        What can we help you
        <br className="d-xl-block d-none" /> today with?
      </h4>

      <div className="row">
        <div className="col-6 mt-4">
          <div
            onClick={() => { navigate("/product/all-drone"); scrollToTop(); }}
            className="cursor_pointer d-flex justify-content-center align-items-center card h-100 text-center p-3"
          >
            <div className="mx-auto">
              <img width={80} src={drone} alt="buy_image" />
            </div>
            <h3 className="fw-bold fs_12 ff_inter color_darkgray mb-0 mt-3">
              Buy Drone
            </h3>
          </div>
        </div>
        <div className="col-6 mt-4">
          <div
            onClick={() => { navigate("/drone-parts"); scrollToTop(); }}
            className="cursor_pointer d-flex justify-content-center align-items-center card h-100 text-center p-3"
          >
            <div className="mx-auto">
              <img width={80} src={image1} alt="image1" />
            </div>
            <h3 className="fw-bold fs_12 ff_inter color_darkgray mb-0 mt-3">
              Drone Spares Parts
            </h3>
          </div>
        </div>
        <div className="col-6 mt-4">
          <div
            onClick={() => { navigate("/jobs-hire-page"); scrollToTop(); }}
            className="cursor_pointer d-flex justify-content-center align-items-center card h-100 text-center p-3"
          >
            <div className="mx-auto">
              <img width={80} src={image2} alt="image2" />
            </div>
            <h3 className="fw-bold fs_12 ff_inter color_darkgray mb-0 mt-3">
              Find Pilot Jobs
            </h3>
          </div>
        </div>
        <div className="col-6 mt-4">
          <div
            onClick={() => { navigate("/training-courses/0"); scrollToTop(); }}
            className="cursor_pointer d-flex justify-content-center align-items-center card h-100 text-center p-3"
          >
            <div className="mx-auto">
              <img width={80} src={image3} alt="image3" />
            </div>
            <h3 className="fw-bold fs_12 ff_inter color_darkgray mb-0 mt-3">
              Become Drone Pilot
            </h3>
          </div>
        </div>
      </div>
    </div>
  </div>

  {/* Second box with related blogs */}
  <div className="mt-3 container" style={{ backgroundColor: 'white' }}>
    <div className="tab_btns rounded-4 p-4">
      <h4 className="fs_26 ff_inter fw-bold text-black text-center">
        Related Blogs
      </h4>
      <Slider className="pb-4" {...blogSliderSettings}>
        {blogs.map((item, index) => (
          <Link
            className="cursor_pointer"
            to={`/blog-details/${item._id}`}
            key={index}
            onClick={scrollToTop}
          >
            <div className="d-flex flex-column mt-4 align-items-center h-100 p-2">
              <div className="col-lg-12 pe-0 pe-lg-3 h-100">
                <img
                  className="w-100 rounded-4 h-100"
                  src={item.image}
                  alt="blog_image"
                />
              </div>
              <div className="col-lg-12 mt-4 mt-lg-0 px-1">
                <div className=" rounded-4">
                  <h4
                    className="mt-4 fs_24 fw-bold ff_helvetica color_darkgray"
                    title={item.heading}
                  >
                    {item.title}
                  </h4>
                </div>
                <p className="ff_helvetica color_darkgray fs_15">
                  {HTMLReactParser(descriptionShort(item, index))}
                </p>
              </div>
            </div>
          </Link>
        ))}
      </Slider>
    </div>
  </div>
</div>

  );
};

export default HowWeCanHelp;
